import ValidationErrors from '../fields/validationErrors';
import { ValidatorRule, ValidatorResult } from './validatorRule.constants';
import { BaseValidator } from './baseValidator';

export class NicknameFieldValidator extends BaseValidator {
    public JPNicknameLengthRule(value: string): ValidatorResult {
        const MAX_LENGTH = 42;
        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
                rule: 'JPNicknameLengthRule',
            };
        }

        return null;
    }

    public EUNicknameLengthRule(value: string): ValidatorResult {
        const MAX_LENGTH = 127;
        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
                rule: 'EUNicknameLengthRule',
            };
        }

        return null;
    }

    constructor(rules = [ValidatorRule.EUNicknameLengthRule]) {
        super(rules);
    }
}
